/**
 * #### Decisyon Srl ####
 * Author 		: Pagano Francesco
 * Date 		: 01.12.2015 
 * Description 	: This factory is responsible for generating and expose the Api to build a menu 
 */
(function(Utilities) {
	'use strict';

	function DcyMenuFactory(dcyMenuOptionsService, $mdMenu, dcyUtilsFactory, $compile, $rootScope) {
		
		/**
		 * This Function is responsible for build a vertical menu
		 * @param templateUrl 	: Template to use for rappresent a menu
		 * @param config 		: #Optional# Configuration Object that contains layoutPosition and Callbacks
		 * @param $scope		: #Optional# scope for compiled menu template
		 */
		function buildMenu(templateUrl, config, $scope){
			if(!dcyUtilsFactory.isValidString(templateUrl)){ 
				throw new Error ('dcyMenuFactory : TemplateUrl ['+templateUrl+'] is not valid.');
			}
			var _self = this,
				menuCtrl = new Object(),
				scope = $scope || $rootScope.$new();
			
			//Show menu
			_self.open = function(target, parent, hasBackdrop, disableParentScroll) {
				$mdMenu.hide().then(function(){
					dcyUtilsFactory.fetchTemplate(templateUrl).then(function(html){
						var $tmpl = $compile(html)(scope);
						var optsMenu = {
								scope		: scope,
								mdMenuCtrl	: menuCtrl,
								element		: $tmpl,
								target		: target,
								parent 		: !Utilities.isUndefinedOrNull(parent) ? parent instanceof HTMLElement ? parent : parent[0] : document.body,
								hasBackdrop :  typeof hasBackdrop === 'boolean' ? hasBackdrop : true,
								disableParentScroll : typeof disableParentScroll === 'boolean' ? disableParentScroll : false
						};
						$mdMenu.show(optsMenu);
								
						if(!optsMenu.hasBackdrop){
							var onScrollHandler = function(){
								dcyUtilsFactory.removeEventListener(optsMenu.parent, 'scroll', onScrollHandler);
								$mdMenu.hide();
							};
							dcyUtilsFactory.addEventListener(optsMenu.parent, 'scroll', onScrollHandler);
						}
					});
				});
			};
			//Close Menu and call relative callback on after clousure
			_self.close = function() { 
				return $mdMenu.hide().then(function(){
					if(config && config.callbacks && typeof config.callbacks.onAfterHideMenu === 'function'){
						config.callbacks.onAfterHideMenu();
					}
				});
			};
			//Private : return position to $mdMenu controller => default append on target
			menuCtrl.positionMode = function() { 
				return (config && config.layout && config.layout.position) ? config.layout.position : {left: 'target', top: 'target'};
			};
			
			//Private : return position offset to $mdMenu controller => default top 0 left 0
			menuCtrl.offsets = function() { 
				return (config && config.layout && config.layout.offsets ? config.layout.offsets : {top:0, left:0});
			};
			
			//Private : return open method to $mdMenu controller
			menuCtrl.open = _self.open;
			//Private : return close method to $mdMenu controller
			menuCtrl.close = _self.close;
		}
		
		/**
		 * This Function is responsible for build a preset menu
		 * @param config 		: Configuration Object that contains all properties expecting relative to menuPreset passed
		 */
		function buildPresetsMenu(config){
			
			var menuConfig 	= dcyMenuOptionsService.initMenuInterface(config),
				scope 		= $rootScope.$new();
			
			scope.dcy_menu = menuConfig;
			
			//Exposed : attach the updateLayout Method
			buildMenu.prototype.updateLayout = function(newLayout){
				angular.merge(scope.dcy_menu.layout, newLayout);
			};
			
			//Exposed : attach the updateTargetInfo Method
			buildMenu.prototype.updateTargetInfo = function(newTargetInfo){
				scope.dcy_menu.objects.targetInfo = newTargetInfo;
			};
			//Exposed : attach the updateData Method
			buildMenu.prototype.updateData = function(newData){
				if(newData.length > 0){
					scope.dcy_menu.objects.data = newData;
				}
			};
			
			return new buildMenu(menuConfig.templateUrl, menuConfig, scope);
		}
		
		return {
			buildMenu 			: buildMenu,
			buildPresetsMenu 	: buildPresetsMenu
		};
	}

	DcyMenuFactory.$inject = ['dcyMenuOptionsService', '$mdMenu', 'dcyUtilsFactory', '$compile', '$rootScope'];
	angular.module('dcyApp').register.factory('dcyMenuFactory', DcyMenuFactory);
}(window.Utilities));